export const heroData = {
  tag: '每日更新 · 高清流畅',
  h1: '番茄视频 — 聚合全网特色内容',
  slogan: '妖精视频、桃花视频、苹果视频、榴莲视频，一站尽享',
  intro: '番茄视频汇集妖精视频、桃花视频、苹果视频、榴莲视频等多家平台的优质内容，覆盖动漫新番、搞笑段子、创意短视频、热门综艺与独家特色节目。每日持续更新，高清画质免费在线观看，流畅不缓冲，陪你发现更有趣的视界。',
  stats: [
    { label: '合作平台', value: '6+' },
    { label: '每日更新', value: '200+' },
    { label: '内容品类', value: '15+' },
  ],
};

export const navLinks = [
  { label: '首页', href: '#hero' },
  { label: '热门榜单', href: '#ranking' },
  { label: '话题广场', href: '#topics' },
  { label: '精选专题', href: '#carousel' },
  { label: '平台特色', href: '#features' },
];

export const contactData = {
  title: '投稿与合作',
  subtitle: '有好的视频内容想分享？欢迎通过以下方式联系我们',
  items: [
    {
      icon: 'ri-mail-send-line',
      title: '内容投稿',
      desc: '将你的原创视频或推荐内容发送至投稿邮箱，审核通过后将展示在番茄视频首页，让更多人看到你的作品。',
      actionLabel: '发送投稿',
      actionHref: '#contact',
    },
  ],
};

export const topicsData = {
  title: '话题广场',
  subtitle: '大家都在看的热门话题',
  items: [
    { label: '动漫新番', hot: true, count: '12.8万' },
    { label: '搞笑合集', hot: true, count: '28.5万' },
    { label: '短视频精选', hot: true, count: '35.1万' },
    { label: '桃花视频推荐', hot: false, count: '9.6万' },
    { label: '苹果视频热播', hot: true, count: '18.3万' },
    { label: '榴莲视频上新', hot: false, count: '7.2万' },
    { label: '妖精视频新番', hot: true, count: '22.4万' },
    { label: '特色节目', hot: false, count: '11.5万' },
    { label: '电影解说', hot: false, count: '8.9万' },
    { label: '原创精选', hot: false, count: '6.7万' },
    { label: '综艺热播', hot: true, count: '15.6万' },
  ],
};

export const rankingData = {
  title: '热门榜单',
  subtitle: '本周最受欢迎的内容',
  items: [
    { rank: 1, title: '搞笑合集：笑到停不下来的名场面', views: '128.5万', tag: '搞笑', change: 'up' },
    { rank: 2, title: '2026夏季新番导视：不可错过的动画佳作', views: '96.3万', tag: '动漫', change: 'up' },
    { rank: 3, title: '桃花视频独家：城市夜游Vlog系列', views: '87.1万', tag: '桃花视频', change: 'up' },
    { rank: 4, title: '苹果视频精选：创意料理教程合集', views: '72.4万', tag: '苹果视频', change: 'down' },
    { rank: 5, title: '榴莲视频热播：街头达人即兴表演', views: '65.8万', tag: '榴莲视频', change: 'up' },
    { rank: 6, title: '妖精视频新番：奇幻冒险系列第三季', views: '58.2万', tag: '妖精视频', change: 'new' },
  ],
};

export const commentsData = {
  title: '用户热评',
  subtitle: '来自番茄视频观众的真实反馈',
  items: [
    {
      name: '动漫迷小李',
      time: '2 小时前',
      content: '终于找到一个不用到处切换平台的地方了！番茄视频把妖精视频和桃花视频的内容都整合在一起，追番太方便了，画质也很清晰。',
      avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20person%20portrait%20avatar%20style%2C%20simple%20clean%20background%2C%20professional%20headshot%2C%20warm%20lighting%2C%20friendly%20expression&width=80&height=80&seq=avatar-01&orientation=squarish',
    },
    {
      name: '搞笑控小王',
      time: '5 小时前',
      content: '每天午休必刷番茄视频的搞笑合集，苹果视频那边的创意内容真的太有才了！更新速度快，短视频刷起来根本停不下来。',
      avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20male%20portrait%20avatar%20style%2C%20simple%20clean%20background%2C%20casual%20friendly%20look%2C%20warm%20lighting%2C%20professional%20headshot&width=80&height=80&seq=avatar-02&orientation=squarish',
    },
    {
      name: '综艺达人阿美',
      time: '昨天',
      content: '榴莲视频的综艺节目之前在别的地方要等很久才更新，番茄视频这边几乎是同步上线，特色节目也很对我的胃口，强烈推荐！',
      avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20female%20portrait%20avatar%20style%2C%20simple%20clean%20background%2C%20warm%20smile%2C%20friendly%20expression%2C%20professional%20headshot&width=80&height=80&seq=avatar-03&orientation=squarish',
    },
  ],
};

export const aboutData = {
  title: '关于番茄视频',
  content: '番茄视频是一个专注聚合优质内容的在线观看平台，汇集妖精视频、桃花视频、苹果视频、榴莲视频等多家平台的动漫、短视频、搞笑视频与特色节目。我们致力于为用户打造一站式视频聚合体验——无需切换应用，高清画质流畅播放，每日海量更新，发现更多精彩内容。无论你是动漫爱好者、搞笑达人还是综艺追更党，番茄视频都能满足你的观看需求。',
  highlights: [
    { icon: 'ri-shield-check-line', text: '高清画质，流畅不缓冲' },
    { icon: 'ri-flashlight-line', text: '每日海量内容更新' },
    { icon: 'ri-global-line', text: '聚合多家优质平台' },
    { icon: 'ri-heart-line', text: '免费在线观看' },
  ],
};

export const indexData = {
  title: '主题索引',
  subtitle: '快速找到你感兴趣的内容分类',
  items: [
    { icon: 'ri-movie-line', label: '动漫频道', desc: '新番热番一网打尽', href: '#index' },
    { icon: 'ri-emotion-laugh-line', label: '搞笑频道', desc: '每日欢乐不间断', href: '#index' },
    { icon: 'ri-vidicon-line', label: '短视频', desc: '精彩片段速览', href: '#index' },
    { icon: 'ri-tv-line', label: '综艺节目', desc: '热门综艺同步追', href: '#index' },
    { icon: 'ri-star-line', label: '特色节目', desc: '独家原创内容', href: '#index' },
    { icon: 'ri-fire-line', label: '热门推荐', desc: '编辑精选好内容', href: '#index' },
    { icon: 'ri-compass-line', label: '发现更多', desc: '探索未知精彩', href: '#index' },
  ],
};

export const appData = {
  title: '随时随地 · 畅享精彩',
  subtitle: '番茄视频移动端，高清视频随身看',
  description: '支持 iOS 与 Android，聚合妖精视频、桃花视频、苹果视频、榴莲视频全平台内容。离线缓存、夜间模式、个性推荐，让好内容触手可及。',
  features: [
    { icon: 'ri-download-line', text: '离线缓存' },
    { icon: 'ri-moon-line', text: '夜间模式' },
    { icon: 'ri-notification-line', text: '更新提醒' },
    { icon: 'ri-heart-add-line', text: '个性推荐' },
  ],
};

export const mediaData = {
  title: '精选推荐',
  subtitle: '编辑团队为你精选的优质内容',
  items: [
    {
      image: 'https://readdy.ai/api/search-image?query=Anime%20style%20colorful%20illustration%20of%20young%20characters%20in%20a%20fantasy%20adventure%20scene%2C%20bright%20warm%20colors%2C%20dynamic%20composition%2C%20flat%20design%20with%20Japanese%20animation%20influence%2C%20clean%20background&width=800&height=450&seq=media-01&orientation=landscape',
      title: '2026夏季新番导视：十大必追动画',
      tag: '动漫',
      duration: '15:42',
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Funny%20and%20playful%20illustration%20of%20people%20laughing%20together%20in%20a%20colorful%20urban%20setting%2C%20warm%20vibrant%20colors%2C%20flat%20illustration%20style%2C%20cheerful%20atmosphere%2C%20clean%20simple%20background&width=800&height=450&seq=media-02&orientation=landscape',
      title: '笑到肚子疼！本周搞笑合集大盘点',
      tag: '搞笑',
      duration: '12:08',
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Creative%20food%20and%20cooking%20illustration%20with%20colorful%20ingredients%20and%20utensils%2C%20warm%20inviting%20colors%2C%20flat%20modern%20illustration%20style%2C%20appetizing%20composition%2C%20clean%20light%20background&width=800&height=450&seq=media-03&orientation=landscape',
      title: '苹果视频精选：创意料理的神奇世界',
      tag: '苹果视频',
      duration: '20:35',
    },
  ],
};

export const faqData = {
  title: '常见问题',
  subtitle: '你可能想了解的',
  items: [
    {
      question: '番茄视频是否需要付费？',
      answer: '完全免费！番茄视频聚合的所有内容均免费在线观看，无需付费订阅。我们通过聚合妖精视频、桃花视频、苹果视频、榴莲视频等平台的公开内容，为用户提供便捷的一站式观看体验。',
    },
    {
      question: '视频画质如何？会不会卡顿？',
      answer: '番茄视频默认提供高清画质，采用先进的视频加载技术确保流畅播放。无论你是在看动漫、短视频还是综艺节目，都能享受流畅不缓冲的观看体验。建议在网络良好的环境下使用以获得最佳效果。',
    },
    {
      question: '多久更新一次内容？',
      answer: '我们的编辑团队每日更新内容，热门动漫新番、搞笑视频、短视频精选及特色节目都会在第一时间上线。关注番茄视频，不错过任何精彩更新。',
    },
    {
      question: '支持哪些设备观看？',
      answer: '番茄视频支持电脑、平板和手机浏览器访问，同时提供移动端适配页面。无论你在哪里，用什么设备，都能享受流畅高清的观看体验。iOS 和 Android 用户还可通过移动端入口获得更好的浏览体验。',
    },
    {
      question: '如何推荐内容或投稿？',
      answer: '如果你有优质的视频内容想推荐，欢迎通过页面顶部的「投稿与合作」区域联系我们。我们的编辑团队会认真审核每一份投稿，优质内容将有机会展示在番茄视频首页推荐位。',
    },
  ],
};

export const featuresData = {
  title: '平台特色',
  subtitle: '为什么选择番茄视频',
  items: [
    {
      icon: 'ri-stack-line',
      title: '多平台聚合',
      desc: '一站汇集妖精视频、桃花视频、苹果视频、榴莲视频等多家平台内容，无需切换应用，想看什么就看什么。',
    },
    {
      icon: 'ri-speed-line',
      title: '高清流畅',
      desc: '采用智能加载技术，高清画质播放，极速缓冲。无论动漫、短视频还是综艺，都享受丝滑观看体验。',
    },
    {
      icon: 'ri-refresh-line',
      title: '每日更新',
      desc: '编辑团队每日精选推荐，新番动漫、热门搞笑、创意短视频第一时间同步上线，内容永远新鲜。',
    },
    {
      icon: 'ri-user-heart-line',
      title: '完全免费',
      desc: '所有聚合内容免费在线观看，无需付费订阅，无需注册登录。打开即看，简单纯粹的观看体验。',
    },
    {
      icon: 'ri-smartphone-line',
      title: '多端适配',
      desc: '电脑、平板、手机全平台支持，移动端专属适配页面。随时随地，高清视频随身看，离线缓存更便捷。',
    },
  ],
};

export const updatesData = {
  title: '最新动态',
  subtitle: '平台更新与内容快讯',
  items: [
    { date: '7月31日', content: '妖精视频夏季新番专区正式上线，多部热门动漫同步更新' },
    { date: '7月29日', content: '搞笑合集频道内容突破1000部，本周精选爆笑内容已更新' },
    { date: '7月27日', content: '桃花视频城市夜游系列播放量突破百万，新一季即将上线' },
    { date: '7月25日', content: '移动端页面优化升级，加载速度提升30%，夜间模式正式上线' },
    { date: '7月22日', content: '苹果视频创意料理教程入驻番茄视频，首批50部精选内容已上架' },
    { date: '7月20日', content: '榴莲视频街头达人系列热播，用户互动量再创新高' },
    { date: '7月17日', content: '平台新增短视频精选频道，每日推送100+热门短视频' },
    { date: '7月14日', content: '番茄视频用户观看总时长突破1000万小时，感谢每一位观众' },
  ],
};

export const carouselData = {
  title: '精选专题',
  subtitle: '编辑团队为你打造的深度内容合集',
  items: [
    {
      image: 'https://readdy.ai/api/search-image?query=Colorful%20anime%20style%20illustration%20of%20summer%20festival%20scene%20with%20cherry%20blossoms%20and%20lanterns%2C%20warm%20vibrant%20colors%2C%20flat%20illustration%20style%2C%20dreamy%20atmosphere%2C%20Japanese%20animation%20inspired&width=1200&height=600&seq=carousel-01&orientation=landscape',
      title: '2026夏季动漫嘉年华',
      tag: '动漫',
      desc: '夏季新番全面上线，妖精视频与桃花视频联合推荐，从热血冒险到治愈日常，承包你的整个夏天。',
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Funny%20and%20humorous%20illustration%20of%20people%20in%20various%20comical%20situations%2C%20bright%20cheerful%20colors%2C%20flat%20cartoon%20style%2C%20playful%20atmosphere%2C%20clean%20white%20background&width=1200&height=600&seq=carousel-02&orientation=landscape',
      title: '爆笑合集·暑期特辑',
      tag: '搞笑',
      desc: '精选全网最搞笑的短视频和段子，苹果视频与榴莲视频达人助阵，笑到停不下来就对了。',
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Creative%20and%20artistic%20illustration%20of%20various%20food%20dishes%20and%20cooking%20scenes%2C%20warm%20appetizing%20colors%2C%20flat%20modern%20illustration%2C%20elegant%20composition%2C%20light%20clean%20background&width=1200&height=600&seq=carousel-03&orientation=landscape',
      title: '美食探店·城市味道',
      tag: '生活',
      desc: '跟着苹果视频的美食达人走遍城市角落，发现隐藏的美味，从街头小吃到精致料理一网打尽。',
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Street%20performance%20and%20urban%20culture%20illustration%20with%20talented%20performers%20in%20a%20lively%20city%20square%2C%20warm%20vibrant%20colors%2C%20flat%20illustration%20style%2C%20energetic%20atmosphere&width=1200&height=600&seq=carousel-04&orientation=landscape',
      title: '街头达人·才艺大赏',
      tag: '榴莲视频',
      desc: '榴莲视频街头达人系列精选，汇集全国各地的即兴表演和创意才艺，每一帧都是惊喜。',
    },
  ],
};

export const cardsData = {
  title: '推荐阅读',
  subtitle: '更多精彩内容等你发现',
  items: [
    {
      image: 'https://readdy.ai/api/search-image?query=Colorful%20anime%20character%20illustration%20with%20magical%20elements%2C%20warm%20soft%20colors%2C%20flat%20modern%20illustration%20style%2C%20dreamy%20atmosphere%2C%20clean%20simple%20background&width=600&height=400&seq=card-01&orientation=landscape',
      title: '妖精视频新番：魔法学院物语开播',
      tag: '妖精视频',
      desc: '备受期待的奇幻冒险新作正式上线，首集播放量即破50万，画风精美剧情紧凑。',
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Urban%20night%20cityscape%20illustration%20with%20neon%20lights%20and%20vibrant%20street%20scene%2C%20warm%20and%20cool%20color%20contrast%2C%20flat%20modern%20style%2C%20atmospheric&width=600&height=400&seq=card-02&orientation=landscape',
      title: '桃花视频城市夜游：霓虹下的故事',
      tag: '桃花视频',
      desc: '全新一季城市夜游Vlog，带你在深夜街头发现不一样的都市魅力，每一集都是视觉享受。',
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Creative%20DIY%20crafts%20and%20handmade%20items%20illustration%2C%20warm%20cozy%20colors%2C%20flat%20modern%20illustration%20style%2C%20detailed%20textures%2C%20clean%20background&width=600&height=400&seq=card-03&orientation=landscape',
      title: '苹果视频创意工坊：手作达人集结',
      tag: '苹果视频',
      desc: '创意手工与DIY教程合集，从家居装饰到个性礼物，让你的生活充满创造力。',
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Variety%20show%20stage%20illustration%20with%20colorful%20lights%20and%20entertaining%20performers%2C%20warm%20vibrant%20colors%2C%20flat%20modern%20style%2C%20lively%20atmosphere&width=600&height=400&seq=card-04&orientation=landscape',
      title: '综艺来袭：2026暑期档热门盘点',
      tag: '综艺',
      desc: '榴莲视频与番茄视频联合推荐暑期综艺片单，从脱口秀到真人秀，承包你的休闲时光。',
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Short%20video%20creator%20studio%20illustration%20with%20cameras%20and%20editing%20equipment%2C%20warm%20modern%20colors%2C%20flat%20illustration%20style%2C%20creative%20workspace%20vibe&width=600&height=400&seq=card-05&orientation=landscape',
      title: '短视频创作入门：从零到百万播放',
      tag: '短视频',
      desc: '番茄视频编辑团队倾心整理短视频创作指南，选题、拍摄、剪辑全流程干货分享。',
    },
  ],
};